export default defineNuxtRouteMiddleware((to, from) => {
  // If the path is not the root path and ends with a slash (/), redirect to the same path without the trailing slash
  // For example, /about/ -> /about
  if (to.path !== '/' && to.path.endsWith('/')) {
    const { path, query, hash } = to
    const nextPath = path.replace(/\/+$/, '') || '/'
    const nextRoute = { path: nextPath, query, hash }
    return navigateTo(nextRoute, { redirectCode: 301 })
  }
})
